import React from "react";
import { string } from "prop-types";
import "./breadcrumb.m.css";

export const Breadcrumb = ({ children }) => {
  return (
    <div styleName="breadcrumb">
      <p>{children}</p>
    </div>
  );
};

Breadcrumb.propTypes = {
  children: string.isRequired,
};